var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fill: "currentColor",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20c5.5 0 10-4.5 10-10S25.5 0 20 0 10 4.5 10 10s4.5 10 10 10m6.7-10a6.7 6.7 0 1 1-13.4 0 6.7 6.7 0 0 1 13.4 0M40 36.7c0 3.3-3.3 3.3-3.3 3.3H3.3S0 40 0 36.7s3.3-13.3 20-13.3 20 9.9 20 13.3m-3.3 0c0-.8-.5-3.3-2.8-5.5-2.2-2.2-6.3-4.4-13.9-4.4S8.3 28.9 6.1 31.1c-2.3 2.3-2.8 4.7-2.8 5.5h33.4z"
  })));
};
export default SvgPerson;